module.exports = __webpack_public_path__ + "static/media/sad_face.17877ab9.svg";